import { formElementHelper, formHelper, FormSchema } from '@jht/react-library';
import { FreeformAutocomplete } from '../../components/Autocomplete/Autocomplete';

const sbuOptions = [
  'Australia',
  'Brazil',
  'Canada',
  'China',
  'France',
  'Germany',
  'Greece',
  'Hong Kong',
  'Italy',
  'Japan',
  'Korea',
  'Malaysia',
  'Mexico',
  'Netherlands',
  'North America',
  'Philippines',
  'Poland',
  'Saudi Arabia',
  'Spain',
  'Taiwan',
  'Thailand',
  'United Kingdom',
  'Vietnam',
];

export const productDetailFormSchema = (values): FormSchema => {
  return formHelper([
    formElementHelper({
      fullWidth: true,
      name: 'smallBusinessUnit',
      col: 12,
      label: 'Strategic Business Unit',
      value: values.productDetails?.smallBusinessUnit || '',
      options: sbuOptions,
      type: 'text',
      required: true,
      validation: { required: true },
      component: FreeformAutocomplete,
    }),
    formElementHelper({
      fullWidth: true,
      col: 12,
      name: 'desiredGoLiveDate',
      label: 'Desired Go Live Date',
      value: values.productDetails?.desiredGoLiveDate || null,
      inputType: 'datePicker',
      format: 'MM/dd/yyyy',
      minDate: new Date(),
    }),
    formElementHelper({
      fullWidth: true,
      col: 12,
      name: 'desiredGoLiveDateNotes',
      label: 'Notes',
      value: values.productDetails?.desiredGoLiveDateNotes,
      inputType: 'multiline',
      rows: '5',
      variant: 'outlined',
    }),
  ]);
};

export const contactInformationFormSchema = (values): FormSchema => {
  return formHelper([
    formElementHelper({
      fullWidth: true,
      col: 4,
      name: 'salesContactName',
      label: 'Sales Contact Name',
      value: values.productDetails?.salesContactName,
      inputType: 'input',
      type: 'text',
    }),
    formElementHelper({
      fullWidth: true,
      col: 4,
      name: 'salesContactEmail',
      label: 'Sales Contact Email',
      value: values.productDetails?.salesContactEmail,
      inputType: 'input',
      type: 'email',
      validation: { isEmail: true },
      validationMessages: {
        isEmail: 'Email Address Invalid',
      },
    }),
    formElementHelper({
      fullWidth: true,
      col: 4,
      name: 'salesContactPhone',
      label: 'Sales Contact Phone',
      value: values.productDetails?.salesContactPhone,
      inputType: 'input',
      type: 'text',
    }),
    formElementHelper({
      fullWidth: true,
      col: 4,
      name: 'customerContactName',
      label: 'Customer Contact Name',
      value: values.productDetails?.customerContactName,
      inputType: 'input',
      type: 'text',
      required: true,
      validation: {
        required: true,
      },
      validationMessages: {
        required: 'Name is required',
      },
    }),
    formElementHelper({
      fullWidth: true,
      col: 4,
      name: 'customerContactEmail',
      label: 'Customer Contact Email',
      value: values.productDetails?.customerContactEmail,
      inputType: 'input',
      type: 'email',
      validation: {
        isEmail: true,
      },
      validationMessages: {
        isEmail: 'Valid Email Address is required',
      },
      required: true,
    }),
    formElementHelper({
      fullWidth: true,
      col: 4,
      name: 'customerContactPhone',
      label: 'Customer Contact Phone',
      value: values.productDetails?.customerContactPhone,
      inputType: 'input',
      type: 'text',
    }),
  ]);
};

export const netpulseOrderDetailsFormSchema = (values, orgName): FormSchema => {
  const elements = [
    formElementHelper({
      fullWidth: true,
      col: 12,
      name: 'chainName',
      label: 'Organization Name',
      value: values.productDetails?.chainName || orgName,
      inputType: 'input',
      type: 'text',
      required: true,
      validation: { required: true },
    }),
    formElementHelper({
      fullWidth: true,
      col: 12,
      name: 'companyWebsite',
      label: 'Company Website',
      value: values.productDetails?.companyWebsite,
      inputType: 'input',
      type: 'text',
      required: true,
      validation: { required: true },
    }),
    formElementHelper({
      fullWidth: true,
      name: 'existingMobileApp',
      col: 12,
      label: 'Existing Mobile App?',
      value: values.productDetails?.existingMobileApp,
      inputType: 'select',
      options: ['1', '0'].map(value => {
        return {
          value: value,
          label: value === '1' ? 'Yes' : 'No',
        };
      }),
      type: 'text',
      required: true,
      validation: { required: true },
    }),
  ];
  if (values.productDetails && values.productDetails.existingMobileApp) {
    if (values.productDetails.existingMobileApp === '1') {
      elements.push(mobileAppNameSchema(values));
    } else if (values.productDetails.existingMobileApp === '0') {
      elements.push(desiredAppNameSchema(values));
    }
  }
  elements.push(
    formElementHelper({
      fullWidth: true,
      col: 12,
      name: 'orderingNotes',
      label: 'Ordering Notes',
      value: values.productDetails?.orderingNotes,
      inputType: 'multiline',
      rows: '5',
      variant: 'outlined',
    }),
  );
  return formHelper(elements);
};

export const mobileAppNameSchema = values => {
  return formElementHelper({
    fullWidth: true,
    col: 12,
    name: 'mobileAppName',
    label: 'Mobile App Name',
    value: values.productDetails?.mobileAppName,
    inputType: 'input',
    type: 'text',
    required: true,
    validation: { required: true },
  });
};

export const desiredAppNameSchema = values => {
  return formElementHelper({
    fullWidth: true,
    col: 12,
    name: 'desiredMobileAppName',
    label: 'Desired Mobile App Name',
    value: values.productDetails?.desiredMobileAppName,
    inputType: 'input',
    type: 'text',
    required: true,
    validation: { required: true },
  });
};
